import { Component, HostListener } from '@angular/core';
import { OffcanvasComponent } from "./offcanvas/offcanvas.component";
import { HeaderComponent } from "./header/header.component";
import { SlidebarComponent } from "./slidebar/slidebar.component";
import { FooterComponent } from "./footer/footer.component";
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-layout',
    imports: [OffcanvasComponent, RouterOutlet, SlidebarComponent, CommonModule],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss'
})
export class LayoutComponent {
  isLoading = true;
  loadingText = ['F', 'i', 'b', 'a', 'n', 'k'];

  ngOnInit() {
    window.addEventListener('load', () => {
      setTimeout(() => {
        this.isLoading = false;
        document.body.style.overflow = 'visible';
      }, 350);
    });
  }
  isScrollBtnVisible = false;

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollTop =
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isScrollBtnVisible = scrollTop > 100; // adjust as needed
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

}
